import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../../styles/pages/Blogs.module.scss"
import Link from 'next/link'
import Topbanner from '../../components/Topbanner/Topbanner'
import { blogsData } from '../../data/blogsData';
import { roomsData } from '../../data/roomsData';
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaLink } from "react-icons/fa";
import { FacebookIcon, FacebookShareButton, InstagramIcon, InstapaperShareButton, WhatsappIcon, WhatsappShareButton } from 'next-share';
import { useState } from 'react';
import BookNowButtonWhite from '../../components/BestDeal/BookNowButtonWhite';

export default function Blog({ blog, Allblogs }) {
    let filteredBlogs = Allblogs.filter(item => item.slug !== blog.slug);
    const similar_blogs = filteredBlogs;
    const [copied, setCopied] = useState(false);

    const handleCopyLink = async () => {
        try {
            const fullUrl = window.location.href;
            await navigator.clipboard.writeText(fullUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
    return (
        <>
            <Head>
                <title>{blog.metaTitle}</title>
                <link rel="icon" href="/favicon.svg" />
                <meta name="description" content={blog?.metaDesc} />
                <link rel="canonical" href={`https://www.hoteltwintowers.com/blogs/${blog?.slug}`} />
                <meta name="keywords" content={blog?.metaKeywords}></meta>
            </Head>

            <section className={styles.single_blog_top_banner}>
            </section>
            <section className={`${styles.single_blog} common_padding`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-8"'>
                            <div className={styles.single_blog_page_top}>
                                <p className='text-left'>Publish on: {blog.date}</p>
                                <h1>{blog.title}</h1>
                                <div className={`${styles.blog_social_links_parent} d-flex`}>
                                    <div className={`${styles.single_blog_destinations_btn} d-flex`}>
                                        <button>Shimla</button>
                                        <button>Kufri</button>
                                        <button>Things To Do </button>
                                    </div>
                                    <div>
                                        Share On:
                                        <div className={`${styles.blog_page_social_links} d-flex`}>
                                            <FacebookShareButton url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}>
                                                <FacebookIcon size={32} round />
                                            </FacebookShareButton>
                                            <InstapaperShareButton url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}>
                                                <InstagramIcon size={32} round />
                                            </InstapaperShareButton>
                                            <WhatsappShareButton url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}>
                                                <WhatsappIcon size={32} round />
                                            </WhatsappShareButton>

                                            <div className={styles.link_icon} onClick={handleCopyLink}>
                                                {copied && <span>Copied!</span>}
                                                <FaLink /></div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className={`${styles.blog_text1} common_title`} dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                        </div>
                        <div className={`${styles.recent_blog_sec} col-12 col-sm-12 col-md-4 col-lg-4`}>
                            <div className={styles.sticky_recent_posts}>
                                <div className={`${styles.recent_top} common_title`}>
                                    <h3 className='text-white'>Recent Posts</h3>
                                </div>
                                <div className={styles.recent_bottom}>
                                    {similar_blogs && similar_blogs.slice(0, 5).map((item) => (
                                        <Link href={`/blogs/${item.slug}`} key={item.slug} className={styles.recent_bottom_main}>
                                            <div>
                                                <Image src={item.bgImage} alt={item.title} width={70} height={70}></Image>
                                            </div>
                                            <div className={styles.recent_bottom_right}>
                                                <p>{item.date}</p>
                                                <h6 className='m-0'>{item.title}</h6>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className={styles.recent_blog_bottom_img_sec} >
                                <div className={styles.recent_blog_bottom_img}>
                                    <Image src={'/images/recent-blog-bottom.png'} layout='fill'></Image>
                                </div>
                                <div className={styles.recent_blog_bottom_img_content}>
                                    <h4>Experience<br></br> Breathtaking Mornings!</h4>
                                    {/* <Link href={'https://thetwintowers.bookingjini.com/property'} target='blank'>
                                        <button className={styles.blog_page_btn}>Book Your Stay Now</button>
                                    </Link> */}

                                    <BookNowButtonWhite />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div className={styles.blog_footer}>
                    <div className={styles.blog_footer_content}>
                        <h4>Your Perfect Stay Awaits</h4>
                        {/* <Link href='https://thetwintowers.bookingjini.com/property' target='_blank' >
                            <button className={styles.blog_page_btn}>Book Now</button>
                        </Link> */}
                        <BookNowButtonWhite />
                    </div>
                </div>
            </footer>
            {/* <div className={`${styles.blogs_sec} pt-2`}>
                <div className='container'>

                    <div className='common_title text-center'>
                        <h2>Recent post</h2>
                    </div>
                    <div className={`${styles.blogs} row`}>
                        {Allblogs.map((blog, index) => (
                            <Link href={`/blogs/${blog.slug}`} className={`${styles.blogs_child} col-md-4`} key={index}>
                                <div className={styles.blog_child_image} style={{ backgroundImage: `url(${blog.bgImage})` }}>
                                    <div className={`${styles.blog_bottom} row align-items-center`}>
                                        <div className='col-md-8 text-center'>
                                            <h4 className=''>{blog.description}</h4>
                                        </div>
                                        <div className='col-md-4 '>
                                            <p className='m-0'>{blog.date}</p>
                                        </div>
                                        <button className={styles.read_more_btn}>Read More</button>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div> */}
            {/* <section className={`${styles.single_blog} common_padding`}>
                <div className='container'>
                    <div className={`${styles.blog_text1} common_title text-center`}>
                        <h2>
                            Lorem ipsum dolor sit amet consectetur
                        </h2>
                        <p>The Super Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay and contains all basic amenities such as Color LCD with Cable, Large windows for the perfect valley views, cozy double bed with quality material, Resting chair, Dressing mirror, Mini Fridge and 24 hrs running hot.Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay and contains all basic amenities such as Color LCD with Cable, Large windows for the perfect valley views, cozy double bed with quality material, Resting chair, Dressing mirror, Mini Fridge and 24 hrs running hot.</p>
                    </div>

                    <div className={`${styles.highlight_div} common_title`}>
                        <h3>The Super Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay.</h3>
                        <h5 className={styles.h5_text}><Image src="/icons/line.svg" width={65} height={10} alt="icon" /> John Smith</h5>
                    </div>

                    <p className="text-center m-0">
                        The Super Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay and contains all basic amenities such as Color LCD with Cable, Large windows for the perfect valley views, cozy double bed with quality material, Resting chair, Dressing mirror, Mini Fridge and 24 hrs running hot and cold water at the attached bathroom.
                    </p>

                    <div className={`${styles.images_sec} row py-5`}>
                        <div className="col-md-6">
                            <img src="/images/single-blog-img1.png" alt='image' />
                        </div>
                        <div className="col-md-6">
                            <img src="/images/single-blog-img2.png" alt='image' />
                        </div>
                    </div>

                    <p className="text-center ">
                        The Super Deluxe rooms offers that luxury and comfort to our guests. The Super deluxe hotel room is finely decorated for your luxurious stay and contains all basic amenities such as Color LCD with Cable, Large windows for the perfect valley views, cozy double bed with quality material, Resting chair, Dressing mirror, Mini Fridge and 24 hrs running hot and cold water at the attached bathroom.
                    </p>

                    <div className={`${styles.blogs_sec} pt-2`}>
                        <div className='common_title text-center'>
                            <h2>Recent post</h2>
                        </div>
                        <div className={`${styles.blogs} row`}>
                            {Allblogs.map((blog, index) => (
                                <Link href="blogs/single-blog" className={`${styles.blogs_child} col-md-4`} key={index}>
                                    <div className={styles.blog_child_image} style={{ backgroundImage: `url(${blog.bgImage})` }}>
                                        <div className={`${styles.blog_bottom} row`}>
                                            <div className='col-md-4'>
                                                <h3>{blog.date}</h3>
                                            </div>
                                            <div className='col-md-8'>
                                                <p>{blog.description}</p>
                                            </div>
                                            <Link href="/">Read More</Link>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}


        </>
    )
}


export const getStaticProps = async ({ params }) => {
    const Allblogs = blogsData
    const currentSlug = params.slug;
    const blog = blogsData.find((blog) => blog.slug === currentSlug) || {
        notfound: true,
    };
    return { props: { blog, Allblogs } };
};

export const getStaticPaths = async () => {
    const paths = blogsData.map((blog) => ({
        params: { slug: blog.slug },
    }));
    return { paths, fallback: false };
};
